import type { AxiosError } from 'axios';

export class ClientApiError extends Error {
  constructor(error: AxiosError<null>) {
    super(error.message);
    this.message = 'Request failed with no response';
    this.name = 'API Error';
  }
}

export class ApiResponseError extends Error {
  readonly status: number;

  constructor(error: AxiosError<ProblemDetails>) {
    super(error.response?.data.title);
    this.status = error.response?.status || 0;
    this.name = `API Error ${error.response?.status}`;
  }
}

export class VersionMismatchError extends ApiResponseError {}

export interface ProblemDetails {
  type: string;
  title: string;
  detail: string;
  status: number;
}
